import logStore from '../store/log.js'
import cacheStore from '../store/cache.js'
import mqttStore from '../store/mqtt.js'
import { sync } from 'vuex-pathify'
import axiosInstances from '../server/axiosInstances'

// return a table if in cache, otherwise retrieve it from server, cache and return
async function fetchTable (table, auth) {
    if (!table) return
    let filterByOrg = false
    switch (table) {
      case 'users' : 
        filterByOrg = true
        auth = true
        break
    }
    console.log('fetching table', table, auth)
    try {
        var res
        if (auth) {
            if (filterByOrg) {
              res = await axiosInstances.loginServer.get('dt/v1/' + table + '?orgonly')
            } else {
              res = await axiosInstances.loginServer.get('dt/v1/' + table)
            }
        } else {
            res = await axiosInstances.apiServer.get('/dt/v1/' + table)
        }
        if (table == "users") console.log('??????: ',res.data)
        return res.data
    } catch (ex) {
        console.log('caching ', table, ' failed: ', ex)
    }
    
}

async function getTable(table) {
    let cache = cacheStore.state.tableCache
    if (cache[table] != undefined) {
      return cache[table]
    }
    if (logStore.state.elog) logStore.state.elog('warn','cache miss for {}', table)()
    let t = await fetchTable(table)
    if (t == null) {
      cache[table] = []
      return []
    }
    cache[table] = t
    return t
}

async function refresh(table) {
    mqttStore.state.mqttTableUpdated = ''
    let cache = cacheStore.state.tableCache
    if (cache[table]) {
        try {
            var res = await axiosInstances.apiServer.get('/dt/v1/' + table)
            cache[table] = res.data
            // console.log('refreshed cache for ', table)
        } catch (ex) {
            console.log('cache refresh for  ', table, ' failed: ', ex)
        }
    }
    mqttStore.state.mqttTableUpdated = table
}

async function cacheTable(table, auth) {
    let cache = cacheStore.state.tableCache
    if (cache[table]) return
    if (auth === 'auth') {
      let res = await axiosInstances.authServer.get('/dt/v1/' + table)
      if (res != null && res.data != null) cache[table] = res.data
        // axiosInstances.authServer.get('/dt/v1/' + table).then (res => {
        //     cache[table] = res.data
        // })
    } else if (auth === 'login') {
      let res = await axiosInstances.loginServer.get('/dt/v1/' + table)
      if (res != null && res.data != null) cache[table] = res.data
        // axiosInstances.loginServer.get('/dt/v1/' + table).then (res => {
        //     cache[table] = res.data
        // })
    } else {
      let res = await axiosInstances.apiServer.get('/dt/v1/' + table)
      if (res != null && res.data != null) cache[table] = res.data
        // axiosInstances.apiServer.get('/dt/v1/' + table).then (res => {
        //     cache[table] = res.data
        // })
    }
}

async function getAsyncObject(table, id) {
    let res = axiosInstances.apiServer.get('/dt/v1/'+table+'/'+id)
    if (res == null || res.data == null) return
    return res.data
}

function getCachedObject(table, id) {
  let cache = cacheStore.state.tableCache
  if (cache[table] == undefined) return null
  let o = cache[table].filter((i) => i._id == id)
  return o[0]
}

function getCachedTable(table) {
  let cache = cacheStore.state.tableCache
  if (cache[table] == undefined) return null
  else return cache[table]
}

async function getObject(table, id) {
  let o = getCachedObject(table, id)
  if (o != null) return o
  await getTable(table)
  return getCachedObject(table, id)
}

async function preload (tables) {
    // console.log('preloading tables: ', tables)
    await Promise.all(tables.map(async function(table) {
        cacheTable(table)
    }))
    return true
}

async function preloadAuth (tables) {
    // console.log('preloading tables: ', tables)
    await Promise.all(tables.map(async function(table) {
        cacheTable(table, 'auth')
    }))
    return true
}

async function preloadLogin (tables) {
    // console.log('preloading tables: ', tables)
    await Promise.all(tables.map(async function(table) {
        cacheTable(table, 'login')
    }))
    return true
}

function reset() {
  cacheStore.state.tableCache = []
}


const cache = {
    getTable,
    fetchTable,
    refresh,
    getObject,
    getCachedObject,
    cacheTable,
    getCachedTable,
    preload,
    preloadAuth,
    preloadLogin,
    reset
}

export default cache